<template>
  <div class="c-designer">
    <div class="filter-form">
      <Button type="primary" @click="down">数据导出</Button>
    </div>
    <Viewport v-model="tableHeight">
      <designer-table
        ref="designerAvgTable"
        :height="tableHeight"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        @on-refresh="filterData"
      />
      <Page
        show-total
        show-sizer
        show-elevator
        size="small"
        class="c-table-page pager"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>
  </div>
</template>

<script>
import mixinTable from './mixin_table'
import columns from '../data/designer_avg_columns'
import { findDesignerAverageInfoByPage } from '@/api/manage.model'
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'

import DesignerTable from './components/designer-avg-table.vue'

export default {
  mixins: [mixinTable],
  name: 'designerAvgData',
  components: { DesignerTable },
  data() {
    return {
      tableHeight: 330,
      loading: false,
      tableData: [],
      columns: columns
    }
  },
  methods: {
    getData() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      this.loading = true
      findDesignerAverageInfoByPage(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info } = data
        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
          this.tableData = list
        } else this.tableData = []
        this.$nextTick(() => {
          this.$refs.designerAvgTable && this.$refs.designerAvgTable.doLayout()
        })
      })
    },
    down() {
      let url = `${HOST_API}/api/ptom/designer/exportDesignerAverageInfo`
      url += `?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      window.open(url)
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.filter-form {
  margin-bottom: 5px;
}
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
